import { ApolloProvider } from '@apollo/client'
import React from 'react'
import { GlobalStyle, ThemeProvider, theme } from 'styled'

import Routes from 'Routes'
import { apolloClient } from 'utils/apolloClient'

import 'App.css'

const App = () => {
  return (
    <ApolloProvider client={apolloClient}>
      <ThemeProvider theme={theme}>
        <Routes />
      </ThemeProvider>
      <GlobalStyle />
    </ApolloProvider>
  )
}

export default App
